export default 'rgba(0,0,0,0)';



// WEBPACK FOOTER //
// ./../src/utilities/Transparent.js